import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { checkString } from "../FunctionsCore";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import ContentTextStyles from "./ContentTextStyles.module.scss";
const styles = ContentTextStyles;
const classCombiner = classCombinerFromPrefix("7efa428bb8d23d1d");
const ContentTextComponent = (properties) => {
    const { textRewritten } = properties;
    return checkString(textRewritten)
        ? _jsx("div", { className: cx(classCombiner(styles, "contenttext")), dangerouslySetInnerHTML: { "__html": textRewritten } })
        : _jsx(_Fragment, {});
};
const contentText = (renderableData) => renderIdentifierGeneric(ContentTextComponent, renderableData);
export { contentText };
